export default "__VITE_ASSET__BX_xvIFK__"